module.exports = __webpack_public_path__ + "img/times.79c3c20f.svg";